/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 25 2023
 **/

import { useState } from "react";
import useDetectClickOutside from "./useOutsideClickEffect";

export default function useCloseToClickOutside<E extends HTMLElement>(props?: {
	onClose?: (ev?: MouseEvent | TouchEvent) => void;
}) {
	const [isShow, setIsShow] = useState(false);

	const handleClose = (ev?: MouseEvent | TouchEvent) => {
		if (isShow) setIsShow(false);
		props?.onClose?.(ev);
	};

	const { ref } = useDetectClickOutside<E>(handleClose, [isShow]);

	return { ref, state: [isShow, setIsShow] as const };
}
